import React from 'react';

import Breadcrumbs, { BreadcrumbsItem } from '@atlaskit/breadcrumbs';
import Heading from '@atlaskit/heading';
import { Box, Inline, Stack, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import type { HeaderProps } from '../../common/types';

const headerContainerStyles = xcss({
	marginTop: 'space.200',
	marginBottom: 'space.200',
	marginLeft: 'space.300',
	marginRight: 'space.300',
	gap: 'space.050',
});

const headerBorder = xcss({
	borderBottom: `1px solid ${token('color.border')}`,
});

const headerElementsSpace = xcss({
	justifyContent: 'space-between',
	alignItems: 'end',
});

export const Header = ({ title, breadcrumbs, actions }: HeaderProps) => {
	return (
		<Stack xcss={headerBorder}>
			<Stack xcss={headerContainerStyles}>
				<Stack>
					<Breadcrumbs>
						{breadcrumbs.map((crumb) => (
							<BreadcrumbsItem href={crumb.href} text={crumb.text} />
						))}
					</Breadcrumbs>
				</Stack>
				<Stack>
					<Inline xcss={headerElementsSpace}>
						<Heading size="large">{title}</Heading>
						{actions && <Box>{actions}</Box>}
					</Inline>
				</Stack>
			</Stack>
		</Stack>
	);
};
